import React from 'react';

import { BaseIconProps } from './';

export const Check = ({ fill }: BaseIconProps) => (
  <path
    d="M 7.777,0.992 6.255,-0.49 1.49,3.928 10.052,12.57 11.576,11.088 4.547,3.928 Z"
    transform="matrix(-4.3710862,-83.966081,83.966081,-4.3710862,68.484522,1121.3685)"
    fill={fill}
  />
);
